module.exports = __webpack_public_path__ + "media/images/flags/iq-7283d56a69b3cc3d949141da790cfb08.svg";